import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';

@Injectable({
  providedIn: 'root'
})
export class RsaEncryptionService {
  private publicKey: string = `
  -----BEGIN RSA PUBLIC KEY-----
  MIGJAoGBAMzHX61EtavSdg/QTTXXbjc/xbYp1oLqjc2oXz7fztGHVf0EV0YXXHe9
  eScSP52PZDZo1dWE7SzTNBwjCs2G8j4veZ/a6I5QsXGRA0WIAIMnyDtFUSm0ulqe
  BtpCSdapp0KccHXivxhiY+1nFLMcSuae1/kDY+Mva4IN38AyAERzAgMBAAE=
  -----END RSA PUBLIC KEY-----
  `;

  constructor() { }

  encryptWithPublicKey(valueToEncrypt: any): string {
    const rsa = Forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(valueToEncrypt.toString()));
  }

}
